module.exports = __webpack_public_path__ + "static/media/AI_For_Everyone.8acabd30.png";